export default __webpack_public_path__ + "static/media/img1.66a7557a.png";